import _ from '../../core/utils'

const API_NEWSLETTE_UNSUBSCRIBE_CONFIG = {
    deleters: _.selectAll( '.newsletter-delete' ),
    endpoint: 'newsletter/unsubscribe/'
}
export default API_NEWSLETTE_UNSUBSCRIBE_CONFIG